'use strict';

var Joi = require('joi');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var pageDataSchema = {
  title: Joi__default["default"].string().optional().allow('').default('').description('Title of page event is fired from. Added from pageData for page_view events.'),
  url: Joi__default["default"].string().uri({
    allowRelative: false
  }).optional().allow('').default('').description('URL of event source.'),
  path: Joi__default["default"].string().optional().allow('').default('').description('Path of event source.'),
  hash: Joi__default["default"].string().optional().allow('').default('').description('Hash params in url, if any exist.'),
  search: Joi__default["default"].string().optional().allow('').default('').description('Search params in url, if any exist.'),
  width: Joi__default["default"].number().optional().allow('').default('').description('Width of the screen at the time the event fired.'),
  height: Joi__default["default"].number().optional().allow('').default('').description('Height of the screen at the time the event fired.'),
  article_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).optional().allow(null, '').description('Id of article the end user is currently on'),
  page_name: Joi__default["default"].string().optional().allow('').default('').description('Name of page event is fired from. Added from pageData for page_view events.')
};
var pageDataSchema$1 = pageDataSchema;

module.exports = pageDataSchema$1;
//# sourceMappingURL=pageDataschema.model.js.map
